import { createI18n } from 'vue-i18n';
// 导入语言包
import zh from '../langurage/zh'
import en from '../langurage/en'

// 安全获取localStorage的函数
const getStoredLanguage = (): string => {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            return localStorage.getItem('Pfdlanguage') || '';
        }
    } catch (error) {
        console.warn('无法访问localStorage:', error);
    }
    return '';
};

// 安全设置localStorage的函数
const setStoredLanguage = (lang: string): void => {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            localStorage.setItem('Pfdlanguage', lang);
        }
    } catch (error) {
        console.warn('无法设置localStorage:', error);
    }
};

// 获取默认语言
const getDefaultLanguage = (): string => {
    const storedLang = getStoredLanguage();
    if (storedLang) {
        return storedLang;
    }

    // 获取浏览器语言偏好
    let browserLang = 'en';
    try {
        if (typeof navigator !== 'undefined' && navigator.language) {
            console.log(navigator.language, '语言偏好');
            if (navigator.language.includes('zh')) {
                browserLang = 'zh';
            } else if (navigator.language.includes('en')) {
                browserLang = 'en';
            } else {
                browserLang = 'en';
            }
            setStoredLanguage(browserLang);
        }
    } catch (error) {
        console.warn('无法获取浏览器语言:', error);
    }

    return browserLang;
};

const messages = {
    zh,
    en
}

const i18n = createI18n({
    legacy: false,  // 设置为 false，启用 composition API 模式
    locale: getDefaultLanguage(),
    fallbackLocale: 'en', // 添加回退语言
    messages,
    globalInjection: true, // 全局注入
    silentTranslationWarn: true, // 静默翻译警告
    silentFallbackWarn: true, // 静默回退警告
})

export default i18n
